import { render, staticRenderFns } from "./NSearchContainer.vue?vue&type=template&id=2095548c&scoped=true&"
import script from "./NSearchContainer.vue?vue&type=script&lang=js&"
export * from "./NSearchContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095548c",
  null
  
)

export default component.exports